import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8dd44d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sources small-reco" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "fushia" }, "*", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" American Society for Colposcopy and Cervical Pathology. Risk Estimates Supporting the 2019 ASCCP Risk-Based Management Consensus Guidelines. 131 Rollins Ave, Suite 2, Rockville, MD 20852 : ASCCP; 2019")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "fushia" }, "*", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" American Society for Colposcopy and Cervical Pathology. Risk Estimates Supporting the 2019 ASCCP Risk-Based Management Consensus Guidelines. 131 Rollins Ave, Suite 2, Rockville, MD 20852 : ASCCP; 2019")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, [
      (!_ctx.isMobile())
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: `${_ctx.sources}`,
            target: "blank"
          }, _hoisted_5, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: 'medics://viewer?m_source=' + _ctx.sources
          }, _hoisted_9, 8, _hoisted_6))
    ])
  ]))
}